import {
  ExecEdStickyCTAProps,
  UseExecEdStickyCTA,
  ExecEdStickyCTAVariants,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "eeStickyCta";

const useExecEdStickyCTA: UseExecEdStickyCTA = () => {
  const { isLoading, value } = useMonarchRule<{
    data: ExecEdStickyCTAProps;
    variantCustomId: ExecEdStickyCTAVariants;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        ctaText: "",
        showDesktop: false,
        showMobile: false,
        bottomCtaText: "",
      },
    };
  }

  return {
    isLoading,
    variant: value?.variantCustomId,
    data: {
      ctaText: value?.data.ctaText || "",
      showDesktop: value?.data.showDesktop || false,
      showMobile: value?.data.showMobile || false,
      bottomCtaText: value?.data.bottomCtaText || "",
    },
  };
};

export default useExecEdStickyCTA;
